import { toast } from 'react-toastify';
import { getErrorTexts } from '../utils';

export const successToastsKeys = {
  settingsUpdate: 'showSuccessNotification',
};

class UIHelper {
  toast = (params = {}, variant = 'success') => {};

  static successNotification = (message = 'stata salvata con successo') => {
    return UIHelper.showSuccessMessage();
    toast.success(message);
  };

  static showRequestErrorToast = () => {
    toast.error('Errore');
  };

  static showCustomMessage = (message) => {
    toast.success(message);
  }

  static showNotFoundErrorToast = () => {
    toast.error('Non e’ trovato');
  };

  static showError = (message = 'Errore') => {
    toast.error(message);
  }

  static showCreateOrUpdateSuccess = () => {
    // toast.success('L’insegna e’ stata salvata con successo');
    UIHelper.showSuccessMessage();
  };

  static showCustomSuccessMessage = (message) => {
    toast.success(message);
  }

  static showServerConfigError = () => {
    toast.error('Oops, server config error');
  };

  static showServerError = () => {
    toast.error('Oops, server error');
  };

  static showRestaurantDisableSuccess = () => {
    UIHelper.showSuccessMessage();
  }

  static showSuccessMessage = () => {
    toast.success('Modifica effettuata con successo');
  }

  static showSuccessNotification = (variant) => {
    return UIHelper.showSuccessMessage();
    switch (variant) {
      case successToastsKeys.settingsUpdate:
        return toast.success('L’insegna e’ stata salvata con successo');
      default:
        return true;
    }
  };

  static showRequestMessage = (errors) => {
    UIHelper.showError(getErrorTexts(errors));
  }

  static downloadFile(response, name) {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', name); //or any other extension
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Download complete remove element
    window.URL.revokeObjectURL(url); // Release blob object
  }
}

export default UIHelper;
